import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconVideoSvg } from "./IconVideoSvg.mjs";
const IconVideo = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconVideoSvg, ...svgProps }) });
export {
  IconVideo
};
